import ColumnTypes from '@/utils/ColumnTypes';

export const getColums = that => {
	const arr = [
		{
			key: 'drDetails',
			label: '达人信息',
			type: () => import('./components/tableCell/talentInfo'),
			minWidth: '250',
			show: true,
			isAuth: true,
		},
		{
			key: 'fans_num',
			label: '粉丝数',
			type: 'rdText',
			minWidth: '100',
			bigger: true,
			show: true,
			isAuth: true,
		},
		{
			key: 'promotion_pro_num',
			label: '30日带货商品数',
			type: 'rdText',
			bigger: true,
			minWidth: '180',
			show: that.$isSp(that.platformId),
			isAuth: true,
		},
		{
			key: 'fee_30',
			label: '30日销售额',
			type: 'rdText',
			bigger: true,
			minWidth: '180',
			show: that.$isSp(that.platformId),
			isAuth: true,
		},
		{
			key: 'live_sale',
			label: '场均销售额',
			type: 'rdText',
			bigger: true,
			minWidth: '180',
			show: that.$isSp(that.platformId),
			isAuth: true,
		},
		{
			key: 'liveCommerce',
			label: '直播带货数据',
			type: () => import('./components/tableCell/liveCommerce'),
			minWidth: '200',
			helpNum: 3,
			helpDesc1: '场均销售额：近30天带货直播场次的平均GMV，剔除开播时间小于25分钟的直播',
			helpDesc2: '直播观看人数：近30天卖货直播的观看人数的中位数',
			helpDesc3: '直播带货场次：近30天带货直播场次数量，剔除开播时间小于25分钟的直播',
			show: that.$isDy(that.platformId),
			isAuth: true,
		},
		{
			key: 'shortVideoCommerce',
			label: '短视频带货数据',
			type: () => import('./components/tableCell/shortVideoCommerce'),
			minWidth: '200',
			helpNum: 2,
			helpDesc1: '带货短视频：近30天发布且挂商品链接的短视频数量',
			helpDesc2: '带货商品数：近30天短视频带货的商品种类',
			show: that.$isDy(that.platformId),
			isAuth: true,
		},
		{
			key: 'live_count_90',
			label: '近90天直播带货次数',
			type: 'rdText',
			bigger: true,
			minWidth: '180',
			show: that.$isKs(that.platformId),
			isAuth: true,
		},
		{
			key: 'avg_price',
			label: '商品均价',
			type: 'rdText',
			bigger: true,
			minWidth: '100',
			show: that.$isKs(that.platformId),
			isAuth: true,
		},
		{
			key: 'anchor_desc',
			label: '简介',
			type: 'rdText',
			ellipsisRow: 3,
			minWidth: '200',
			show: that.$isDy(that.platformId) || that.$isKs(that.platformId),
			isAuth: true,
		},
		{
			key: 'is_contact',
			label: '合作状态',
			type: () => import('./components/tableCell/contactStatus'),
			minWidth: '80',
			show: true,
			isAuth: true,
		},
		{
			key: 'operations',
			label: '操作',
			type: ColumnTypes.ButtonsCell,
			minWidth: '80',
			align: 'right',
			show: true,
			isAuth: true,
		},
	];
	return arr;
};

export const TALENT = 'talent';
export const DYALLIANCE = 'dyAlliance';

export const funcList = that => {
	const arr = [
		{
			name: '线索公海',
			page: TALENT,
			new: false,
			isAuth: 'talentCRM:clueSeas:talentSquare:listBtn',
			show: true,
		},
		{
			name: '插件找达人',
			page: DYALLIANCE,
			new: true,
			isAuth: 'talentCRM:clueSeas:dyAllianceList',
			show: that.$isKs(that.platformId) || that.$isDy(that.platformId),
		},
	];
	return arr;
};
